// File: client/src/variants/royale/index.js
// Chess Royale as a platform plugin.

import rulebook from './rulebook';
import { useRoyaleRuntime } from './useRoyaleRuntime';

const royaleVariant = {
  id: 'royale',
  name: 'Chess Royale',
  tagline: 'Battle-royale chess — the board collapses until one king remains.',
  icon: '🌀',
  accent: 'from-orange-600 to-red-700',
  supportedGameTypes: ['ai', 'local'],
  order: 2,
  rulebook,
  useRuntime: useRoyaleRuntime,
};

export default royaleVariant;
